export default {
  myNeeds: {
    title: "智污邦-行业资讯",
    meta: [{
        name: "keywords",
        content: "关键字1,关键字1,关键字1"
      },
      {
        name: "description",
        content: "这是一段网页的描述1"
      }
    ]
  },
  industry_information: {
    title: "智污邦-行业资讯",
    meta: [{
        name: "keywords",
        content: "关键字2,关键字2,关键字2"
      },
      {
        name: "description",
        content: "这是一段网页的描述2"
      }
    ]
  },
  info_detail: {
    title: "智污邦-资讯详情",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  technology: {
    title: "智污邦-环保技术",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  environmental_housekeeper: {
    title: "智污邦-环保管家",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  classification_list: {
    title: "智污邦-首页-分类",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  data_center: {
    title: "智污邦-资料中心",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  data_detail: {
    title: "智污邦-资料详情",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  supply_demand: {
    title: "智污邦-供需平台",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  supply_detail: {
    title: "智污邦-供应详情",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  demand_detail: {
    title: "智污邦-需求详情",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  environmental_college: {
    title: "智污邦-环学院",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  environmental_college_detail: {
    title: "智污邦-课件详情",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  },
  my_needs: {
    title: "智污邦-我的需求",
    meta: [{
        name: "keywords",
        content: "关键字3,关键字3,关键字3"
      },
      {
        name: "description",
        content: "这是一段网页的描述3"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/assets/vue-meta-info.js